import { useState } from "react";

const Accordion = ({
  item,
  num,
  indexNum,
  clickHandler,
  children,
  extraClasses,
}) => {
  const isExpanded = num === indexNum;

  return (
    <div
      className={`accordion ${extraClasses || ''}`}
      role="region"
      aria-labelledby={`accordion-header-${indexNum}`}
    >
      <div
        id={`accordion-header-${indexNum}`}
        className="head relative text-[#000000] text-[15px] lg:text-[1.2vw] font-secondary ps-4 pe-7 py-4 lg:p-[1vw]"
        onClick={() => clickHandler(indexNum)}
        role="button"
        aria-expanded={isExpanded}
        aria-controls={`accordion-content-${indexNum}`}
        tabIndex={0}
      >
        <span className="sm:pr-[10px]">
          {item.designation || item.head || item.question}
        </span>
        <span
          className="absolute block right-[10px] text-[20px] lg:text-[1.5vw] font-secondary top-[10px] lg:top-[0.8vw] font-bold"
          aria-hidden="true"
        >
          {isExpanded ? "-" : "+"}
        </span>
      </div>


      <div
        id={`accordion-content-${indexNum}`}
        className={`relative content transition duration-300 ease-in-out overflow-hidden box-border ${isExpanded ? "max-h-screen opacity-100" : "max-h-0 opacity-0 lg:opacity-0"
          }`}

      >
        {children}
      </div>
    </div>
  );
};

export default Accordion;